<template>
    <div class="section pt-1 mb-2">

        <!-- Page Tabs -->
        <div class="report-tabs">
            <button type="button" class="report-tab mal-text"
                :class="{ active: page === 'karad' }"
                @click="page='karad'">
                കരട് റിപ്പോർട്ട്
            </button>
            <button type="button" class="report-tab mal-text"
                :class="{ active: page === 'receipt' }"
                @click="page='receipt'">
                റസീപ്റ്റ് റിപ്പോർട്ട്
            </button>
        </div>

        <!-- ══════════════════════ KARAD REPORT ══════════════════════ -->
        <template v-if="page === 'karad'">

            <!-- Filters -->
            <div class="card p-1 mb-1" style="border-radius:12px;margin-top:0!important;">
                <div style="display:flex;gap:8px;align-items:center;">
                    <select v-if="user_level === 1" v-model="district_id"
                        class="form-select form-select-sm" style="flex:1;"
                        @change="onDistrictChange">
                        <option value="">All Districts</option>
                        <option v-for="d in districts" :key="d.id" :value="d.id">{{ d.name }}</option>
                    </select>
                    <select v-if="user_level <= 2" v-model="zone_id"
                        class="form-select form-select-sm" style="flex:1;">
                        <option value="">All Zones</option>
                        <option v-for="z in zones" :key="z.id" :value="z.id">{{ z.name }}</option>
                    </select>
                    <select v-if="user_level >= 2" v-model="unit_id" class="form-select form-select-sm" style="flex:1;">
                        <option value="">All Units</option>
                        <option v-for="u in unit_options" :key="u.id" :value="u.id">{{ u.name }}</option>
                    </select>
                    <button type="button" class="btn btn-primary btn-sm" @click="loadReport" style="padding:6px 14px;flex-shrink:0;">
                        <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                        <ion-icon v-show="!loading" name="search-outline"></ion-icon>
                    </button>
                </div>
            </div>

            <div v-if="loading" class="text-center py-4">
                <div class="spinner-border text-primary"></div>
            </div>

            <template v-else-if="summary">
                <!-- Summary Card -->
                <div class="card mb-1" style="border-radius:14px;overflow:hidden;">
                    <div class="p-1">
                        <div style="display:grid;grid-template-columns:repeat(3,1fr);gap:6px;margin-bottom:6px;">
                            <div class="stat-card" style="background:#f4f7ff;">
                                <div class="stat-value" style="color:#1a418c;">{{ summary.members_in_karad + summary.non_members_count }}</div>
                                <div class="stat-label mal-text">ആകെ എണ്ണം</div>
                            </div>
                            <div class="stat-card" style="background:#f4f7ff;">
                                <div class="stat-value" style="color:#1a418c;">{{ summary.members_in_karad }}</div>
                                <div class="stat-label mal-text">മെമ്പർമാർ</div>
                            </div>
                            <div class="stat-card" style="background:#fff8f0;">
                                <div class="stat-value" style="color:#e67e22;">{{ summary.non_members_count }}</div>
                                <div class="stat-label mal-text">അല്ലാത്തവർ</div>
                            </div>
                        </div>
                        <div style="display:grid;grid-template-columns:repeat(2,1fr);gap:6px;margin-bottom:6px;">
                            <div class="stat-card" style="background:#f0fff6;">
                                <div class="stat-value" style="color:#1DCC70;">{{ summary.visited_members }}</div>
                                <div class="stat-label mal-text">മെമ്പർമാരിൽ നിന്നും വിസിറ്റ് ചെയ്തവർ</div>
                            </div>
                            <div class="stat-card" style="background:#fff5f5;">
                                <div class="stat-value" style="color:#e74c3c;">{{ summary.not_visited }}</div>
                                <div class="stat-label mal-text">ചെയ്യാത്തവർ</div>
                            </div>
                        </div>
                        <div style="display:grid;grid-template-columns:repeat(2,1fr);gap:6px;">
                            <div class="stat-card" style="background:#f0fff6;">
                                <div class="stat-value" style="color:#1DCC70;font-size:15px;">₹{{ summary.collected_members }}</div>
                                <div class="stat-label mal-text">മെമ്പർമാരിൽ നിന്നും കിട്ടിയത്</div>
                            </div>
                            <div class="stat-card" style="background:#f0fff6;">
                                <div class="stat-value" style="color:#1DCC70;font-size:15px;">₹{{ summary.collected_non_members }}</div>
                                <div class="stat-label mal-text">മെമ്പർ അല്ലാത്തവരിൽ നിന്നും കിട്ടിയത്</div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Karad sub-tabs -->
                <div style="display:flex;gap:6px;margin-bottom:8px;">
                    <button type="button"
                        :style="{flex:1,padding:'8px',borderRadius:'10px',border:'none',fontWeight:'700',fontSize:'12px',
                            background: tab==='not_added' ? '#e74c3c' : '#f0f0f0',
                            color: tab==='not_added' ? '#fff' : '#666'}"
                        @click="tab='not_added'" class="mal-text">
                        ചേർക്കാത്ത ({{ filteredNotAdded.length }})
                    </button>
                    <button type="button"
                        :style="{flex:1,padding:'8px',borderRadius:'10px',border:'none',fontWeight:'700',fontSize:'12px',
                            background: tab==='added' ? '#1DCC70' : '#f0f0f0',
                            color: tab==='added' ? '#fff' : '#666'}"
                        @click="tab='added'" class="mal-text">
                        ചേർത്തത് ({{ filteredAdded.length }})
                    </button>
                </div>

                <!-- Not Added grouped (district → zone → unit) when no zone filter -->
                <div v-if="tab === 'not_added'">
                    <div v-if="!not_added.length" class="text-center text-muted py-3 mal-text" style="font-size:13px;">
                        എല്ലാ യൂണിറ്റുകളും ചേർത്തിട്ടുണ്ട്
                    </div>
                    <!-- Grouped view -->
                    <template v-else-if="user_level <= 2 && !zone_id">
                        <template v-for="dg in karadNotAddedByDistrict" :key="'dna_' + dg.district_id">
                            <div v-if="user_level === 1"
                                style="padding:8px 4px 4px;font-size:12px;font-weight:800;color:#e74c3c;letter-spacing:0.5px;text-transform:uppercase;border-bottom:2px solid #fde8e8;margin-bottom:6px;margin-top:10px;">
                                {{ dg.district_name }}
                            </div>
                            <div v-for="zg in dg.zones" :key="'zna_' + zg.zone_name" class="mb-2">
                                <div :style="{background:'#fff',border:'1px solid #e0e0e0',borderRadius: collapsedKaradZones['na_' + zg.zone_name] ? '10px' : '10px 10px 0 0',padding:'10px 14px',cursor:'pointer'}"
                                    @click="toggleKaradZone('na_' + zg.zone_name)">
                                    <div style="display:flex;align-items:center;justify-content:space-between;gap:8px;">
                                        <span style="font-size:13px;font-weight:700;color:#27173E;flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">{{ zg.zone_name }}</span>
                                        <div style="display:flex;align-items:center;gap:6px;flex-shrink:0;">
                                            <span style="font-size:10px;background:#fee;color:#e74c3c;padding:2px 8px;border-radius:8px;font-weight:700;border:1px solid #fdc5c5;white-space:nowrap;" class="mal-text">
                                                {{ zg.units.length }} ചേർക്കാത്തത്
                                            </span>
                                            <ion-icon :name="collapsedKaradZones['na_' + zg.zone_name] ? 'chevron-forward-outline' : 'chevron-down-outline'" style="font-size:15px;color:#aaa;flex-shrink:0;"></ion-icon>
                                        </div>
                                    </div>
                                </div>
                                <div v-show="!collapsedKaradZones['na_' + zg.zone_name]" style="border:1px solid #e0e0e0;border-top:none;border-radius:0 0 10px 10px;overflow:hidden;padding:6px 8px;background:#fafafa;">
                                    <div v-for="(u, idx) in zg.units" :key="u.id"
                                        style="display:flex;align-items:center;gap:8px;background:#fff;border-radius:8px;padding:8px 10px;margin-bottom:5px;border:1px solid #fde8e8;border-left:3px solid #e74c3c;">
                                        <span style="color:#ddd;font-size:11px;width:16px;flex-shrink:0;text-align:right;">{{ idx + 1 }}</span>
                                        <div style="flex:1;min-width:0;">
                                            <div style="font-size:12px;font-weight:700;color:#27173E;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{{ u.name }}</div>
                                        </div>
                                        <span style="font-size:10px;background:#fee;color:#e74c3c;padding:3px 8px;border-radius:8px;font-weight:700;flex-shrink:0;border:1px solid #fdc5c5;" class="mal-text">ചേർത്തിട്ടില്ല</span>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </template>
                    <!-- Flat list when zone selected or level 3 -->
                    <template v-else>
                        <div v-for="(u, idx) in filteredNotAdded" :key="u.id"
                            class="card mb-1" style="border-radius:10px;padding:10px 12px;display:flex;flex-direction:row;align-items:center;gap:10px;">
                            <span style="color:#ddd;font-size:12px;width:20px;flex-shrink:0;text-align:right;">{{ idx + 1 }}</span>
                            <div style="flex:1;min-width:0;">
                                <div style="font-size:13px;font-weight:700;color:#e74c3c;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{{ u.name }}</div>
                                <div style="font-size:10px;color:#aaa;margin-top:2px;">{{ u.zone_name }}</div>
                            </div>
                            <span style="font-size:10px;background:#fee;color:#e74c3c;padding:3px 8px;border-radius:10px;font-weight:700;flex-shrink:0;">ചേർത്തിട്ടില്ല</span>
                        </div>
                    </template>
                </div>

                <!-- Added grouped (district → zone → unit) when no zone filter -->
                <div v-else>
                    <div v-if="!added.length" class="text-center text-muted py-3 mal-text" style="font-size:13px;">
                        ആരും ചേർത്തിട്ടില്ല
                    </div>
                    <!-- Grouped view -->
                    <template v-else-if="user_level <= 2 && !zone_id">
                        <template v-for="dg in karadAddedByDistrict" :key="'da_' + dg.district_id">
                            <div v-if="user_level === 1"
                                style="padding:8px 4px 4px;font-size:12px;font-weight:800;color:#1a418c;letter-spacing:0.5px;text-transform:uppercase;border-bottom:2px solid #e8eef8;margin-bottom:6px;margin-top:10px;">
                                {{ dg.district_name }}
                            </div>
                            <div v-for="zg in dg.zones" :key="'za_' + zg.zone_name" class="mb-2">
                                <div :style="{background:'#fff',border:'1px solid #e0e0e0',borderRadius: collapsedKaradZones['aa_' + zg.zone_name] ? '10px' : '10px 10px 0 0',padding:'10px 14px',cursor:'pointer'}"
                                    @click="toggleKaradZone('aa_' + zg.zone_name)">
                                    <div style="display:flex;align-items:center;justify-content:space-between;gap:8px;">
                                        <span style="font-size:13px;font-weight:700;color:#27173E;flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">{{ zg.zone_name }}</span>
                                        <div style="display:flex;align-items:center;gap:6px;flex-shrink:0;">
                                            <span style="font-size:10px;background:#f0fff6;color:#1DCC70;padding:2px 8px;border-radius:8px;font-weight:700;border:1px solid #b7f5d0;white-space:nowrap;">
                                                {{ zg.units.length }} യൂണിറ്റ്
                                            </span>
                                            <ion-icon :name="collapsedKaradZones['aa_' + zg.zone_name] ? 'chevron-forward-outline' : 'chevron-down-outline'" style="font-size:15px;color:#aaa;flex-shrink:0;"></ion-icon>
                                        </div>
                                    </div>
                                </div>
                                <div v-show="!collapsedKaradZones['aa_' + zg.zone_name]" style="border:1px solid #e0e0e0;border-top:none;border-radius:0 0 10px 10px;overflow:hidden;padding:6px 8px;background:#fafafa;">
                                    <div v-for="(u, idx) in zg.units" :key="u.id"
                                        style="display:flex;align-items:center;gap:8px;background:#fff;border-radius:8px;padding:8px 10px;margin-bottom:5px;border:1px solid #e8f5ee;border-left:3px solid #1DCC70;">
                                        <span style="color:#ddd;font-size:11px;width:16px;flex-shrink:0;text-align:right;">{{ idx + 1 }}</span>
                                        <div style="flex:1;min-width:0;">
                                            <div style="font-size:12px;font-weight:700;color:#27173E;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{{ u.name }}</div>
                                        </div>
                                        <div style="display:flex;flex-direction:column;align-items:flex-end;gap:4px;flex-shrink:0;">
                                            <span style="font-size:18px;font-weight:900;color:#1a418c;line-height:1;">{{ u.total }}</span>
                                            <div style="display:flex;gap:4px;">
                                                <span style="font-size:11px;font-weight:700;background:#fee;color:#e74c3c;padding:2px 7px;border-radius:6px;border:1px solid #fdc5c5;">{{ u.pending }}</span>
                                                <span style="font-size:11px;font-weight:700;background:#f0fff6;color:#1DCC70;padding:2px 7px;border-radius:6px;border:1px solid #b7f5d0;">{{ u.collected }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </template>
                    <!-- Flat list when zone selected or level 3 -->
                    <template v-else>
                        <div v-for="(u, idx) in filteredAdded" :key="u.id"
                            class="card mb-1" style="border-radius:10px;padding:10px 12px;display:flex;flex-direction:row;align-items:center;gap:10px;">
                            <span style="color:#ddd;font-size:12px;width:20px;flex-shrink:0;text-align:right;">{{ idx + 1 }}</span>
                            <div style="flex:1;min-width:0;">
                                <div style="font-size:13px;font-weight:700;color:#27173E;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{{ u.name }}</div>
                                <div style="font-size:10px;color:#aaa;margin-top:2px;">{{ u.zone_name }}</div>
                            </div>
                            <div style="text-align:right;flex-shrink:0;">
                                <div style="font-size:16px;font-weight:800;color:#1a418c;line-height:1;">{{ u.total }}</div>
                                <div style="font-size:10px;color:#aaa;margin-top:2px;">
                                    <span style="color:#e74c3c;">{{ u.pending }}</span>
                                    <span style="color:#ccc;"> / </span>
                                    <span style="color:#1DCC70;">{{ u.collected }}</span>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </template>
        </template>

        <!-- ══════════════════════ RECEIPT REPORT ══════════════════════ -->
        <template v-else>

            <!-- Receipt filters -->
            <div class="card p-1 mb-1" style="border-radius:12px;margin-top:0!important;">
                <div style="display:flex;gap:8px;align-items:center;">
                    <select v-if="user_level === 1" v-model="r_district_id"
                        class="form-select form-select-sm" style="flex:1;"
                        @change="onReceiptDistrictChange">
                        <option value="">All Districts</option>
                        <option v-for="d in districts" :key="d.id" :value="d.id">{{ d.name }}</option>
                    </select>
                    <select v-if="user_level <= 2" v-model="r_zone_id"
                        class="form-select form-select-sm" style="flex:1;"
                        @change="onReceiptZoneChange">
                        <option value="">All Zones</option>
                        <option v-for="z in r_zones" :key="z.id" :value="z.id">{{ z.name }}</option>
                    </select>
                    <select v-if="user_level >= 2" v-model="r_unit_id" class="form-select form-select-sm" style="flex:1;">
                        <option value="">All Units</option>
                        <option v-for="u in r_unit_options" :key="u.id" :value="u.id">{{ u.name }}</option>
                    </select>
                    <button type="button" class="btn btn-primary btn-sm" @click="loadReceiptReport" style="padding:6px 14px;flex-shrink:0;">
                        <span v-show="r_loading" class="spinner-border spinner-border-sm"></span>
                        <ion-icon v-show="!r_loading" name="search-outline"></ion-icon>
                    </button>
                </div>
                <!-- Percentage pills — shown once data is loaded -->
                <div v-if="r_loaded && !r_loading" style="display:flex;gap:6px;margin-top:8px;">
                    <div v-if="user_level === 1"
                        :style="{
                            flex:1, textAlign:'center', padding:'6px 4px', borderRadius:'10px',
                            background: receiptDistrictPercent===100 ? '#f0fff6' : (receiptDistrictPercent===0 ? '#fff0f0' : '#fff8ed'),
                            border: '1.5px solid ' + (receiptDistrictPercent===100 ? '#1DCC70' : (receiptDistrictPercent===0 ? '#e74c3c' : '#f0a500'))
                        }">
                        <div :style="{fontSize:'16px',fontWeight:'900',lineHeight:'1',color: receiptDistrictPercent===100 ? '#1DCC70' : (receiptDistrictPercent===0 ? '#e74c3c' : '#f0a500')}">{{ receiptDistrictPercent }}%</div>
                        <div style="font-size:9px;color:#888;font-weight:600;margin-top:2px;line-height:1.2;" class="mal-text">ജില്ല</div>
                    </div>
                    <div :style="{
                            flex:1, textAlign:'center', padding:'6px 4px', borderRadius:'10px',
                            background: receiptZonePercent===100 ? '#f0fff6' : (receiptZonePercent===0 ? '#fff0f0' : '#fff8ed'),
                            border: '1.5px solid ' + (receiptZonePercent===100 ? '#1DCC70' : (receiptZonePercent===0 ? '#e74c3c' : '#f0a500'))
                        }">
                        <div :style="{fontSize:'16px',fontWeight:'900',lineHeight:'1',color: receiptZonePercent===100 ? '#1DCC70' : (receiptZonePercent===0 ? '#e74c3c' : '#f0a500')}">{{ receiptZonePercent }}%</div>
                        <div style="font-size:9px;color:#888;font-weight:600;margin-top:2px;line-height:1.2;" class="mal-text">മണ്ഡലം</div>
                    </div>
                    <div :style="{
                            flex:1, textAlign:'center', padding:'6px 4px', borderRadius:'10px',
                            background: receiptUnitPercent===100 ? '#f0fff6' : (receiptUnitPercent===0 ? '#fff0f0' : '#fff8ed'),
                            border: '1.5px solid ' + (receiptUnitPercent===100 ? '#1DCC70' : (receiptUnitPercent===0 ? '#e74c3c' : '#f0a500'))
                        }">
                        <div :style="{fontSize:'16px',fontWeight:'900',lineHeight:'1',color: receiptUnitPercent===100 ? '#1DCC70' : (receiptUnitPercent===0 ? '#e74c3c' : '#f0a500')}">{{ receiptUnitPercent }}%</div>
                        <div style="font-size:9px;color:#888;font-weight:600;margin-top:2px;line-height:1.2;" class="mal-text">ശാഖ</div>
                    </div>
                </div>
            </div>

            <div v-if="r_loading" class="text-center py-4">
                <div class="spinner-border text-primary"></div>
            </div>

            <div v-else-if="!r_loaded" class="text-center py-5" style="color:#aaa;">
                <ion-icon name="receipt-outline" style="font-size:36px;margin-bottom:8px;display:block;"></ion-icon>
                <div class="mal-text" style="font-size:13px;">സെർച്ച് ബട്ടൺ അമർത്തുക</div>
            </div>

            <template v-else>

                <!-- Summary: unit/zone/district count rows -->
                <!-- Units -->
                <div style="display:grid;grid-template-columns:repeat(3,1fr);gap:6px;margin-bottom:5px;">
                    <div style="background:#f4f7ff;border-radius:12px;padding:10px 6px;text-align:center;">
                        <div style="font-size:18px;font-weight:800;color:#1a418c;line-height:1;">{{ receipt_received_list.length + receipt_not_received_list.length }}</div>
                        <div style="font-size:10px;color:#888;font-weight:600;margin-top:3px;" class="mal-text">ആകെ യൂണിറ്റ്</div>
                    </div>
                    <div style="background:#f0fff6;border-radius:12px;padding:10px 6px;text-align:center;">
                        <div style="font-size:18px;font-weight:800;color:#1DCC70;line-height:1;">{{ receipt_received_list.length }}</div>
                        <div style="font-size:10px;color:#888;font-weight:600;margin-top:3px;" class="mal-text">ലഭിച്ചത്</div>
                    </div>
                    <div style="background:#fff3e0;border-radius:12px;padding:10px 6px;text-align:center;">
                        <div style="font-size:18px;font-weight:800;color:#e67e22;line-height:1;">{{ receipt_not_received_list.length }}</div>
                        <div style="font-size:10px;color:#888;font-weight:600;margin-top:3px;" class="mal-text">ലഭിക്കാത്തത്</div>
                    </div>
                </div>
                <!-- Zones (only when viewing multiple zones) -->
                <div v-if="user_level <= 2 && !r_zone_id" style="display:grid;grid-template-columns:repeat(3,1fr);gap:6px;margin-bottom:5px;">
                    <div style="background:#f4f7ff;border-radius:12px;padding:10px 6px;text-align:center;">
                        <div style="font-size:18px;font-weight:800;color:#1a418c;line-height:1;">{{ zoneReceiptStats.total }}</div>
                        <div style="font-size:10px;color:#888;font-weight:600;margin-top:3px;" class="mal-text">ആകെ മണ്ഡലം</div>
                    </div>
                    <div style="background:#f0fff6;border-radius:12px;padding:10px 6px;text-align:center;">
                        <div style="font-size:18px;font-weight:800;color:#1DCC70;line-height:1;">{{ zoneReceiptStats.received }}</div>
                        <div style="font-size:10px;color:#888;font-weight:600;margin-top:3px;" class="mal-text">ലഭിച്ചത്</div>
                    </div>
                    <div style="background:#fff3e0;border-radius:12px;padding:10px 6px;text-align:center;">
                        <div style="font-size:18px;font-weight:800;color:#e67e22;line-height:1;">{{ zoneReceiptStats.not_received }}</div>
                        <div style="font-size:10px;color:#888;font-weight:600;margin-top:3px;" class="mal-text">ലഭിക്കാത്തത്</div>
                    </div>
                </div>
                <!-- Districts (only state admin viewing all) -->
                <div v-if="user_level === 1 && !r_district_id" style="display:grid;grid-template-columns:repeat(3,1fr);gap:6px;margin-bottom:6px;">
                    <div style="background:#f4f7ff;border-radius:12px;padding:10px 6px;text-align:center;">
                        <div style="font-size:18px;font-weight:800;color:#1a418c;line-height:1;">{{ districtReceiptStats.total }}</div>
                        <div style="font-size:10px;color:#888;font-weight:600;margin-top:3px;" class="mal-text">ആകെ ജില്ല</div>
                    </div>
                    <div style="background:#f0fff6;border-radius:12px;padding:10px 6px;text-align:center;">
                        <div style="font-size:18px;font-weight:800;color:#1DCC70;line-height:1;">{{ districtReceiptStats.received }}</div>
                        <div style="font-size:10px;color:#888;font-weight:600;margin-top:3px;" class="mal-text">ലഭിച്ചത്</div>
                    </div>
                    <div style="background:#fff3e0;border-radius:12px;padding:10px 6px;text-align:center;">
                        <div style="font-size:18px;font-weight:800;color:#e67e22;line-height:1;">{{ districtReceiptStats.not_received }}</div>
                        <div style="font-size:10px;color:#888;font-weight:600;margin-top:3px;" class="mal-text">ലഭിക്കാത്തത്</div>
                    </div>
                </div>

                <!-- View toggle + pending sub-tabs, together in one card -->
                <div class="filter-card">
                    <div style="display:flex;gap:6px;">
                        <button type="button"
                            :style="{flex:1,padding:'8px',borderRadius:'10px',border:'none',fontWeight:'700',fontSize:'12px',
                                background: !r_show_pending_only ? '#1a418c' : '#f0f0f0',
                                color: !r_show_pending_only ? '#fff' : '#666'}"
                            @click="r_show_pending_only = false" class="mal-text">
                            എല്ലാം
                        </button>
                        <button type="button"
                            :style="{flex:1,padding:'8px',borderRadius:'10px',border:'none',fontWeight:'700',fontSize:'12px',
                                background: r_show_pending_only ? '#e74c3c' : '#f0f0f0',
                                color: r_show_pending_only ? '#fff' : '#666'}"
                            @click="r_show_pending_only = true; r_pending_level = 'unit'" class="mal-text">
                            ലഭിക്കാത്തത് ({{ receipt_not_received_list.length }})
                        </button>
                    </div>

                    <!-- Pending level sub-tabs (only shown in pending mode, multi-zone view) -->
                    <div v-if="r_show_pending_only && user_level <= 2 && !r_zone_id" class="pending-tabs">
                        <button v-if="user_level === 1" type="button" class="pending-tab mal-text"
                            :class="{ active: r_pending_level === 'district' }"
                            @click="r_pending_level='district'">
                            ജില്ല ({{ pendingDistrictsList.length }})
                        </button>
                        <button type="button" class="pending-tab mal-text"
                            :class="{ active: r_pending_level === 'zone' }"
                            @click="r_pending_level='zone'">
                            മണ്ഡലം ({{ pendingZonesList.length }})
                        </button>
                        <button type="button" class="pending-tab mal-text"
                            :class="{ active: r_pending_level === 'unit' }"
                            @click="r_pending_level='unit'">
                            ശാഖ ({{ receipt_not_received_list.length }})
                        </button>
                        <button type="button" class="pending-tab orange mal-text"
                            :class="{ active: r_pending_level === 'undistributed' }"
                            @click="r_pending_level='undistributed'; loadUndistributed()">
                            വിതരണം ചെയ്യാത്തവ ({{ ud_zones.length }})
                        </button>
                    </div>
                </div>

                <!-- Pending districts list -->
                <div v-if="r_show_pending_only && r_pending_level==='district' && user_level===1">
                    <div v-if="!pendingDistrictsList.length" class="text-center text-muted py-4 mal-text" style="font-size:13px;">
                        എല്ലാ ജില്ലകൾക്കും ലഭിച്ചിട്ടുണ്ട്
                    </div>
                    <div v-for="(d, idx) in pendingDistrictsList" :key="d.district_id || d.district_name"
                        style="display:flex;align-items:center;gap:10px;background:#fff;border-radius:10px;padding:10px 14px;margin-bottom:6px;border:1px solid #fde8e8;border-left:3px solid #e74c3c;">
                        <span style="color:#ddd;font-size:12px;width:20px;flex-shrink:0;text-align:right;">{{ idx + 1 }}</span>
                        <div style="font-size:13px;font-weight:700;color:#27173E;flex:1;">{{ d.district_name }}</div>
                        <span style="font-size:10px;background:#fee;color:#e74c3c;padding:3px 8px;border-radius:8px;font-weight:700;border:1px solid #fdc5c5;" class="mal-text">ലഭിച്ചിട്ടില്ല</span>
                    </div>
                </div>

                <!-- Pending zones list -->
                <div v-else-if="r_show_pending_only && r_pending_level==='zone'">
                    <div v-if="!pendingZonesList.length" class="text-center text-muted py-4 mal-text" style="font-size:13px;">
                        എല്ലാ മണ്ഡലങ്ങൾക്കും ലഭിച്ചിട്ടുണ്ട്
                    </div>
                    <template v-else>
                        <!-- District sub-header for state admin -->
                        <template v-if="user_level===1">
                            <div v-for="(dg, dIdx) in pendingZonesByDistrict" :key="'pzd_'+dIdx">
                                <div style="padding:8px 4px 4px;font-size:12px;font-weight:800;color:#e74c3c;letter-spacing:0.5px;text-transform:uppercase;border-bottom:2px solid #fde8e8;margin-bottom:6px;margin-top:10px;">
                                    {{ dg.district_name }}
                                </div>
                                <div v-for="(z, idx) in dg.zones" :key="z.zone_id || z.zone_name"
                                    style="display:flex;align-items:center;gap:10px;background:#fff;border-radius:10px;padding:10px 14px;margin-bottom:6px;border:1px solid #fde8e8;border-left:3px solid #e74c3c;">
                                    <span style="color:#ddd;font-size:12px;width:20px;flex-shrink:0;text-align:right;">{{ idx + 1 }}</span>
                                    <div style="font-size:13px;font-weight:700;color:#27173E;flex:1;">{{ z.zone_name }}</div>
                                    <span style="font-size:10px;background:#fee;color:#e74c3c;padding:3px 8px;border-radius:8px;font-weight:700;border:1px solid #fdc5c5;" class="mal-text">ലഭിച്ചിട്ടില്ല</span>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <div v-for="(z, idx) in pendingZonesList" :key="z.zone_id || z.zone_name"
                                style="display:flex;align-items:center;gap:10px;background:#fff;border-radius:10px;padding:10px 14px;margin-bottom:6px;border:1px solid #fde8e8;border-left:3px solid #e74c3c;">
                                <span style="color:#ddd;font-size:12px;width:20px;flex-shrink:0;text-align:right;">{{ idx + 1 }}</span>
                                <div style="font-size:13px;font-weight:700;color:#27173E;flex:1;">{{ z.zone_name }}</div>
                                <span style="font-size:10px;background:#fee;color:#e74c3c;padding:3px 8px;border-radius:8px;font-weight:700;border:1px solid #fdc5c5;" class="mal-text">ലഭിച്ചിട്ടില്ല</span>
                            </div>
                        </template>
                    </template>
                </div>

                <!-- Undistributed zones (reached but gave nothing to units), grouped by district -->
                <div v-else-if="r_show_pending_only && r_pending_level==='undistributed'">
                    <div v-if="ud_loading" class="text-center py-4">
                        <div class="spinner-border text-warning"></div>
                    </div>
                    <template v-else>
                        <div v-if="!ud_zones.length" class="text-center text-success py-4 mal-text" style="font-size:13px;">
                            ✓ എല്ലാ മണ്ഡലങ്ങളും ശാഖകൾക്ക് വിതരണം ചെയ്തിട്ടുണ്ട്
                        </div>
                        <div v-for="(dg, dIdx) in undistributedByDistrict" :key="'udd_'+dIdx">
                            <div style="padding:8px 4px 4px;font-size:12px;font-weight:800;color:#e67e22;letter-spacing:0.5px;text-transform:uppercase;border-bottom:2px solid #fdecd8;margin-bottom:6px;margin-top:10px;">
                                {{ dg.district_name }}
                            </div>
                            <div v-for="(z, idx) in dg.zones" :key="z.zone_id"
                                style="display:flex;align-items:center;gap:10px;background:#fff;border-radius:10px;padding:10px 14px;margin-bottom:6px;border:1px solid #fdecd8;border-left:3px solid #e67e22;">
                                <span style="color:#ddd;font-size:12px;width:20px;flex-shrink:0;text-align:right;">{{ idx + 1 }}</span>
                                <div style="flex:1;min-width:0;">
                                    <div style="font-size:13px;font-weight:700;color:#27173E;">{{ z.zone_name }}</div>
                                    <div style="font-size:10px;color:#aab;" class="mal-text">{{ z.units_count }} ശാഖ</div>
                                </div>
                                <span style="font-size:10px;background:#fff8ed;color:#e67e22;padding:3px 8px;border-radius:8px;font-weight:700;border:1px solid #fde8b0;white-space:nowrap;">
                                    📕 {{ z.books_held }}
                                </span>
                            </div>
                        </div>
                    </template>
                </div>

                <!-- Zone-grouped by district (unit view) -->
                <div v-else-if="user_level <= 2 && !r_zone_id">
                    <div v-if="zonesByDistrict.length === 0" class="text-center text-muted py-4 mal-text" style="font-size:13px;">
                        എല്ലാ യൂണിറ്റുകൾക്കും റസീപ്റ്റ് ലഭിച്ചിട്ടുണ്ട്
                    </div>
                    <template v-for="dg in zonesByDistrict">
                        <!-- District header — only shown for state admin -->
                        <div v-if="user_level === 1" :key="'d_' + dg.district_name"
                            style="padding:8px 4px 4px;font-size:12px;font-weight:800;color:#1a418c;letter-spacing:0.5px;text-transform:uppercase;border-bottom:2px solid #e8eef8;margin-bottom:6px;margin-top:10px;">
                            {{ dg.district_name }}
                        </div>
                    <div v-for="zg in dg.zones" :key="zg.zone_id" class="mb-2">
                        <!-- Zone header -->
                        <div :style="{background:'#fff',border:'1px solid #e0e0e0',borderRadius: collapsedZones[zg.zone_id] ? '10px' : '10px 10px 0 0',padding:'11px 14px',cursor:'pointer'}"
                            @click="toggleZone(zg.zone_id)">
                            <div style="display:flex;align-items:center;justify-content:space-between;">
                                <span style="font-size:14px;font-weight:700;color:#27173E;">{{ zg.zone_name }}</span>
                                <ion-icon :name="collapsedZones[zg.zone_id] ? 'chevron-forward-outline' : 'chevron-down-outline'" style="font-size:15px;color:#aaa;"></ion-icon>
                            </div>
                            <!-- Zone & Unit receipt status row -->
                            <div style="display:flex;gap:6px;margin-top:6px;flex-wrap:wrap;">
                                <!-- Zone receipt status -->
                                <span v-if="zg.zone_receipt_book_no"
                                    style="font-size:10px;background:#f0fff6;color:#1DCC70;padding:2px 9px;border-radius:8px;font-weight:700;border:1px solid #b7f5d0;">
                                    സോൺ: {{ zg.zone_receipt_book_no }}
                                </span>
                                <span v-else
                                    style="font-size:10px;background:#fff5f5;color:#e74c3c;padding:2px 9px;border-radius:8px;font-weight:700;border:1px solid #fdc5c5;" class="mal-text">
                                    സോൺ: ലഭിച്ചിട്ടില്ല
                                </span>
                                <!-- Units receipt summary -->
                                <span v-if="r_show_pending_only"
                                    style="font-size:10px;background:#fff5f5;color:#e74c3c;padding:2px 9px;border-radius:8px;font-weight:700;border:1px solid #fdc5c5;" class="mal-text">
                                    ലഭിക്കാത്തത്: {{ zg.units.length }} യൂണിറ്റ്
                                </span>
                                <!-- Zone not received → units can't have received either -->
                                <span v-else-if="!zg.zone_receipt_book_no"
                                    style="font-size:10px;background:#fff5f5;color:#e74c3c;padding:2px 9px;border-radius:8px;font-weight:700;border:1px solid #fdc5c5;" class="mal-text">
                                    ലഭിക്കാത്തത്: {{ zg.units.length }} യൂണിറ്റ്
                                </span>
                                <!-- Zone received → show unit-level progress -->
                                <span v-else
                                    :style="{
                                        fontSize:'10px', padding:'2px 9px', borderRadius:'8px', fontWeight:'700',
                                        background: zg.received_count === 0 ? '#fff5f5' : (zg.received_count === zg.units.length ? '#f0fff6' : '#fff8ed'),
                                        color:      zg.received_count === 0 ? '#e74c3c' : (zg.received_count === zg.units.length ? '#1DCC70' : '#f0a500'),
                                        border: '1px solid ' + (zg.received_count === 0 ? '#fdc5c5' : (zg.received_count === zg.units.length ? '#b7f5d0' : '#fde8b0'))
                                    }" class="mal-text">
                                    യൂണിറ്റ്: {{ zg.received_count }}/{{ zg.units.length }}
                                </span>
                            </div>
                        </div>
                        <!-- Units list -->
                        <div v-show="!collapsedZones[zg.zone_id]" style="border:1px solid #e0e0e0;border-top:none;border-radius:0 0 10px 10px;overflow:hidden;transition:all 0.2s;">
                            <!-- Pending mode: zone pending but all units received -->
                            <div v-if="r_show_pending_only && zg.units.length === 0"
                                style="padding:9px 14px;font-size:11px;color:#1DCC70;text-align:center;" class="mal-text">
                                എല്ലാ യൂണിറ്റുകൾക്കും ലഭിച്ചിട്ടുണ്ട്
                            </div>
                            <div v-for="(u, idx) in zg.units" :key="u.id"
                                :style="{
                                    padding:'9px 12px',
                                    display:'flex',
                                    flexDirection:'column',
                                    gap:'6px',
                                    background: u.receipt_book_no ? '#f4f7ff' : '#fff',
                                    borderTop: idx > 0 ? '1px solid #f0f0f0' : 'none',
                                    borderLeft: u.receipt_book_no ? '3px solid #1a418c' : '3px solid transparent'
                                }">
                                <!-- Top row: index + name + book badge -->
                                <div style="display:flex;align-items:center;gap:8px;width:100%;">
                                    <span style="color:#bbb;font-size:11px;width:18px;flex-shrink:0;text-align:right;">{{ idx + 1 }}</span>
                                    <div style="flex:1;min-width:0;">
                                        <div style="font-size:12px;font-weight:700;color:#27173E;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{{ u.name }}</div>
                                    </div>
                                    <span v-if="u.receipt_book_no" style="font-size:12px;background:#eef3ff;color:#1a418c;padding:3px 10px;border-radius:10px;font-weight:700;border:1px solid #d0dbff;flex-shrink:0;">
                                        {{ u.receipt_book_no }}
                                    </span>
                                    <span v-else style="font-size:10px;background:#fff5f5;color:#e74c3c;padding:3px 8px;border-radius:10px;font-weight:700;flex-shrink:0;border:1px solid #fdc5c5;" class="mal-text">
                                        ലഭിച്ചിട്ടില്ല
                                    </span>
                                </div>
                                <!-- Holder name full-width row -->
                                <div v-if="u.holder_name" style="display:flex;align-items:center;gap:5px;margin-left:26px;font-size:12px;font-weight:600;color:#1a418c;background:#eef3ff;border:1px solid #d0dbff;border-radius:8px;padding:4px 10px;">
                                    <ion-icon name="person-outline" style="font-size:13px;flex-shrink:0;"></ion-icon>
                                    <span>{{ u.holder_name }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    </template>
                </div>

                <!-- Flat list when zone is selected or level 3 -->
                <div v-else>
                    <div v-for="(u, idx) in allUnitsFlat" :key="u.id"
                        class="card mb-1" style="border-radius:10px;padding:10px 12px;display:flex;flex-direction:column;gap:6px;">
                        <div style="display:flex;align-items:center;gap:10px;">
                            <span style="color:#ddd;font-size:12px;width:20px;flex-shrink:0;text-align:right;">{{ idx + 1 }}</span>
                            <div style="flex:1;min-width:0;">
                                <div :style="{fontSize:'13px',fontWeight:'700',color: u.receipt_book_no ? '#27173E' : '#e74c3c',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}">
                                    {{ u.name }}
                                </div>
                            </div>
                            <span v-if="u.receipt_book_no" style="font-size:12px;background:#eef3ff;color:#1a418c;padding:3px 10px;border-radius:10px;font-weight:700;border:1px solid #d0dbff;flex-shrink:0;">
                                {{ u.receipt_book_no }}
                            </span>
                            <span v-else style="font-size:10px;background:#fee;color:#e74c3c;padding:3px 8px;border-radius:10px;font-weight:700;flex-shrink:0;" class="mal-text">
                                ലഭിച്ചിട്ടില്ല
                            </span>
                        </div>
                        <!-- Holder name full-width row -->
                        <div v-if="u.holder_name" style="display:flex;align-items:center;gap:5px;margin-left:30px;font-size:12px;font-weight:600;color:#1a418c;background:#eef3ff;border:1px solid #d0dbff;border-radius:8px;padding:4px 10px;">
                            <ion-icon name="person-outline" style="font-size:13px;flex-shrink:0;"></ion-icon>
                            <span>{{ u.holder_name }}</span>
                        </div>
                    </div>
                </div>

            </template>
        </template>

    </div>
</template>

<style scoped>
/* Segmented report tabs — equal width, single line, compact for 375px */
.report-tabs {
    display: flex;
    gap: 4px;
    margin-bottom: 10px;
    background: #f0f0f0;
    border-radius: 12px;
    padding: 4px;
}
.report-tab {
    flex: 1;
    min-width: 0;
    padding: 8px 4px;
    border: none;
    border-radius: 9px;
    background: transparent;
    color: #666;
    font-weight: 700;
    font-size: 12px;
    line-height: 1.2;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
}
.report-tab.active {
    background: #1a418c;
    color: #fff;
    box-shadow: 0 2px 6px rgba(26, 65, 140, 0.25);
}

/* Card wrapping the view toggle + pending sub-tabs */
.filter-card {
    background: #fff;
    border: 1px solid #eef0f5;
    border-radius: 12px;
    padding: 10px;
    margin-bottom: 10px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
}

/* Pending-level sub-tabs — equal 2-column grid, uniform height, compact for 375px */
.pending-tabs {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 5px;
    margin-top: 8px;
    padding-top: 8px;
    border-top: 1px solid #f0f0f0;
}
.pending-tab {
    padding: 8px 6px;
    border: none;
    border-radius: 8px;
    background: #f0f0f0;
    color: #666;
    font-weight: 700;
    font-size: 11px;
    line-height: 1.2;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
}
.pending-tab.active {
    background: #e74c3c;
    color: #fff;
}
.pending-tab.orange.active {
    background: #e67e22;
}

.stat-card {
    border-radius: 10px;
    padding: 10px 6px;
    text-align: center;
}
.stat-value {
    font-size: 20px;
    font-weight: 800;
    line-height: 1.1;
}
.stat-label {
    font-size: 11px;
    color: #888;
    font-weight: 600;
    margin-top: 3px;
    line-height: 1.3;
}
</style>

<script>
import { mapGetters } from 'vuex'
import UserService from '../../services/user.service'

export default {
    name: 'KaradListReport',
    data() {
        return {
            page: 'karad',

            // Karad report
            loading: false,
            user_level: 0,
            districts: [],
            zones: [],
            district_id: '',
            zone_id: '',
            unit_id: '',
            unit_options: [],
            summary: null,
            added: [],
            not_added: [],
            tab: 'not_added',

            collapsedKaradZones: {},

            // Receipt report
            r_loading: false,
            r_loaded: false,
            r_district_id: '',
            r_zone_id: '',
            r_zones: [],
            r_unit_id: '',
            r_unit_options: [],
            receipt_received_list: [],
            receipt_not_received_list: [],
            collapsedZones: {},
            r_show_pending_only: false,
            r_pending_level: 'unit',

            // Zones reached but not distributed to units
            ud_loading: false,
            ud_loaded: false,
            ud_district_id: '',
            ud_zones: [],
        }
    },
    computed: {
        ...mapGetters({ currentUser: 'currentUser' }),
        // District display order: Kerala south→north (1-14), Malappuram South (26) after Malappuram (10), other-state districts (15+) at end
        districtSortKey() {
            const ORDER = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 26, 11, 12, 13, 14, 15, 16, 17]
            const map = {}
            ORDER.forEach((id, idx) => { map[id] = idx })
            return (districtId) => map[districtId] !== undefined ? map[districtId] : 999
        },
        filteredNotAdded() {
            return this.unit_id ? this.not_added.filter(u => u.id == this.unit_id) : this.not_added
        },
        filteredAdded() {
            return this.unit_id ? this.added.filter(u => u.id == this.unit_id) : this.added
        },
        // Karad "not added" units grouped by district → zone
        karadNotAddedByDistrict() {
            return this._karadGroupByDistrict(this.filteredNotAdded)
        },
        // Karad "added" units grouped by district → zone
        karadAddedByDistrict() {
            return this._karadGroupByDistrict(this.filteredAdded)
        },
        // All units merged (received + not received), grouped by zone
        allUnitsByZone() {
            const map = {}
            const all = [
                ...this.receipt_received_list,
                ...this.receipt_not_received_list,
            ].filter(u => !this.r_unit_id || u.id == this.r_unit_id)
            all.forEach(u => {
                // Skip units whose zone no longer exists (stale zone_id, no zone_name)
                if (u.zone_id && !u.zone_name) return
                const key = u.zone_id || 0
                if (!map[key]) {
                    map[key] = {
                        zone_id: key,
                        zone_name: u.zone_name || 'Unknown',
                        district_id: u.district_id || 0,
                        district_name: u.district_name || '',
                        zone_receipt_book_no: u.zone_receipt_book_no || null,
                        units: [],
                        received_count: 0,
                    }
                }
                map[key].units.push(u)
                if (u.receipt_book_no) map[key].received_count++
                if (u.zone_receipt_book_no && !map[key].zone_receipt_book_no) {
                    map[key].zone_receipt_book_no = u.zone_receipt_book_no
                }
            })
            return Object.values(map)
                .sort((a, b) => this.districtSortKey(a.district_id) - this.districtSortKey(b.district_id) || a.zone_id - b.zone_id)
                .map(zg => ({ ...zg, units: zg.units.sort((a, b) => a.name.localeCompare(b.name)) }))
        },
        // Zones grouped by district for display
        zonesByDistrict() {
            const distMap = {}
            const zones = this.r_show_pending_only ? this.pendingOnlyZones : this.allUnitsByZone
            zones.forEach(zg => {
                const key = zg.district_id || 0
                if (!distMap[key]) {
                    distMap[key] = { district_id: key, district_name: zg.district_name || 'Unknown', zones: [] }
                }
                distMap[key].zones.push(zg)
            })
            return Object.values(distMap).sort((a, b) => this.districtSortKey(a.district_id) - this.districtSortKey(b.district_id))
        },
        // Only zones/units that haven't received
        pendingOnlyZones() {
            return this.allUnitsByZone
                .map(zg => {
                    const pendingUnits = zg.units.filter(u => !u.receipt_book_no)
                    return {
                        ...zg,
                        units: pendingUnits,
                        pending_unit_count: pendingUnits.length,
                    }
                })
                // Show zone if zone itself is pending OR has pending units
                .filter(zg => !zg.zone_receipt_book_no || zg.pending_unit_count > 0)
        },
        // Flat merged list for zone-selected view
        allUnitsFlat() {
            return [...this.receipt_received_list, ...this.receipt_not_received_list]
                .sort((a, b) => a.name.localeCompare(b.name))
        },
        pendingDistrictsList() {
            const map = {}
            const all = [...this.receipt_received_list, ...this.receipt_not_received_list]
            all.forEach(u => {
                const key = u.district_id || ('n_' + u.district_name)
                if (!map[key]) map[key] = { district_id: u.district_id, district_name: u.district_name, received: false }
                if (u.district_receipt_book_no) map[key].received = true
            })
            return Object.values(map).filter(d => !d.received)
                .sort((a, b) => this.districtSortKey(a.district_id) - this.districtSortKey(b.district_id) || a.district_name.localeCompare(b.district_name))
        },
        pendingZonesList() {
            const map = {}
            const all = [...this.receipt_received_list, ...this.receipt_not_received_list]
            all.forEach(u => {
                const key = u.zone_id || ('n_' + u.zone_name)
                if (!map[key]) map[key] = { zone_id: u.zone_id, zone_name: u.zone_name, district_id: u.district_id, district_name: u.district_name, received: false }
                if (u.zone_receipt_book_no) map[key].received = true
            })
            return Object.values(map).filter(z => !z.received)
                .sort((a, b) => this.districtSortKey(a.district_id) - this.districtSortKey(b.district_id) || a.zone_name.localeCompare(b.zone_name))
        },
        pendingZonesByDistrict() {
            const distMap = {}
            this.pendingZonesList.forEach(z => {
                const key = z.district_id || ('n_' + z.district_name)
                if (!distMap[key]) distMap[key] = { district_id: z.district_id, district_name: z.district_name, zones: [] }
                distMap[key].zones.push(z)
            })
            return Object.values(distMap).sort((a, b) =>
                this.districtSortKey(a.district_id) - this.districtSortKey(b.district_id) || a.district_name.localeCompare(b.district_name)
            )
        },
        zoneReceiptStats() {
            const map = {}
            const all = [...this.receipt_received_list, ...this.receipt_not_received_list]
            all.forEach(u => {
                const key = u.zone_id || ('n_' + u.zone_name)
                if (!map[key]) map[key] = { received: false }
                if (u.zone_receipt_book_no) map[key].received = true
            })
            const zones = Object.values(map)
            const received = zones.filter(z => z.received).length
            return { total: zones.length, received, not_received: zones.length - received }
        },
        districtReceiptStats() {
            const map = {}
            const all = [...this.receipt_received_list, ...this.receipt_not_received_list]
            all.forEach(u => {
                const key = u.district_id || ('n_' + u.district_name)
                if (!map[key]) map[key] = { received: false }
                if (u.district_receipt_book_no) map[key].received = true
            })
            const districts = Object.values(map)
            const received = districts.filter(d => d.received).length
            return { total: districts.length, received, not_received: districts.length - received }
        },
        receiptDistrictPercent() {
            const all = [...this.receipt_received_list, ...this.receipt_not_received_list]
            const districtMap = {}
            all.forEach(u => {
                const key = u.district_id || 0
                if (!districtMap[key]) districtMap[key] = { total: 0, received: false }
                districtMap[key].total++
                if (u.district_receipt_book_no) districtMap[key].received = true
            })
            const entries = Object.values(districtMap)
            if (!entries.length) return 0
            const receivedCount = entries.filter(d => d.received).length
            return Math.round((receivedCount / entries.length) * 100)
        },
        receiptZonePercent() {
            const zones = this.allUnitsByZone
            if (!zones.length) return 0
            const received = zones.filter(zg => !!zg.zone_receipt_book_no).length
            return Math.round((received / zones.length) * 100)
        },
        receiptUnitPercent() {
            const total = this.receipt_received_list.length + this.receipt_not_received_list.length
            if (!total) return 0
            return Math.round((this.receipt_received_list.length / total) * 100)
        },
        // Undistributed zones grouped by district
        undistributedByDistrict() {
            const distMap = {}
            this.ud_zones.forEach(z => {
                const key = z.district_id || ('n_' + z.district_name)
                if (!distMap[key]) distMap[key] = { district_id: z.district_id, district_name: z.district_name || 'Unknown', zones: [] }
                distMap[key].zones.push(z)
            })
            return Object.values(distMap)
                .map(dg => ({ ...dg, zones: dg.zones.sort((a, b) => (a.zone_name || '').localeCompare(b.zone_name || '')) }))
                .sort((a, b) => this.districtSortKey(a.district_id) - this.districtSortKey(b.district_id) || (a.district_name || '').localeCompare(b.district_name || ''))
        },
    },
    watch: {
        zone_id() {
            this.unit_id = ''
            this.unit_options = []
        },
        page(val) {
            if (val === 'receipt' && !this.r_loaded && !this.r_loading) {
                this.loadReceiptReport()
            }
        },
    },
    mounted() {
        this.user_level = parseInt(this.$route.params.sub_level)
        if (this.user_level === 1) {
            this.loadDistricts()
        } else if (this.user_level === 2) {
            this.district_id   = parseInt(this.$route.params.id)
            this.r_district_id = parseInt(this.$route.params.id)
            this.loadZones(this.district_id)
            this.loadReceiptZones(this.r_district_id)
        } else if (this.user_level === 3) {
            this.zone_id   = parseInt(this.$route.params.id)
            this.r_zone_id = parseInt(this.$route.params.id)
        }
        this.loadReport()
    },
    methods: {
        toggleZone(zoneId) {
            this.collapsedZones = { ...this.collapsedZones, [zoneId]: !this.collapsedZones[zoneId] }
        },
        toggleKaradZone(key) {
            this.collapsedKaradZones = { ...this.collapsedKaradZones, [key]: !this.collapsedKaradZones[key] }
        },
        _karadGroupByDistrict(units) {
            // Build name-based sort key from the already-correctly-sorted districts list
            const districtNameOrder = {}
            this.districts.forEach((d, idx) => { districtNameOrder[d.name] = idx })
            const distSort = (id, name) => {
                if (id && this.districtSortKey(id) !== 999) return this.districtSortKey(id)
                if (districtNameOrder[name] !== undefined) return districtNameOrder[name]
                return 999
            }

            const zoneMap = {}
            units.forEach(u => {
                // Skip units whose zone no longer exists (stale zone_id, no zone_name)
                if (u.zone_id && !u.zone_name) return
                const zKey = (u.zone_id != null && u.zone_id !== 0) ? ('id_' + u.zone_id) : ('n_' + (u.zone_name || ''))
                if (!zoneMap[zKey]) {
                    zoneMap[zKey] = {
                        zone_id: u.zone_id || 0,
                        zone_name: u.zone_name || '',
                        district_id: u.district_id || 0,
                        district_name: u.district_name || '',
                        units: [],
                    }
                }
                zoneMap[zKey].units.push(u)
            })
            const zones = Object.values(zoneMap)
                .sort((a, b) => {
                    const dSort = distSort(a.district_id, a.district_name) - distSort(b.district_id, b.district_name)
                    if (dSort !== 0) return dSort
                    return (a.zone_id || 0) !== 0 ? (a.zone_id - b.zone_id) : a.zone_name.localeCompare(b.zone_name)
                })
                .map(zg => ({ ...zg, units: zg.units.sort((a, b) => a.name.localeCompare(b.name)) }))
            const distMap = {}
            zones.forEach(zg => {
                const dKey = (zg.district_id !== 0) ? ('id_' + zg.district_id) : ('n_' + zg.district_name)
                if (!distMap[dKey]) {
                    distMap[dKey] = { district_id: zg.district_id, district_name: zg.district_name, zones: [] }
                }
                distMap[dKey].zones.push(zg)
            })
            return Object.values(distMap).sort((a, b) =>
                distSort(a.district_id, a.district_name) - distSort(b.district_id, b.district_name)
            )
        },

        // Karad report
        loadDistricts() {
            const EXCLUDED = [18, 19, 20, 21, 22, 23, 24, 25, 27, 28, 735]
            UserService.authGetRequest('get-districts').then((response) => {
                if (response.data.status === 'success') {
                    const all = response.data.data.list || response.data.data || []
                    const ORDER = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 26, 11, 12, 13, 14, 15, 16, 17]
                    const orderMap = {}
                    ORDER.forEach((id, idx) => { orderMap[id] = idx })
                    this.districts = all
                        .filter(d => !EXCLUDED.includes(d.id))
                        .sort((a, b) => (orderMap[a.id] !== undefined ? orderMap[a.id] : 999) - (orderMap[b.id] !== undefined ? orderMap[b.id] : 999))
                }
            })
        },
        onDistrictChange() {
            this.zone_id = ''
            this.zones = []
            this.unit_id = ''
            this.unit_options = []
            if (this.district_id) this.loadZones(this.district_id)
        },
        loadZones(districtId) {
            UserService.authGetRequest('get-zones', { district_id: districtId }).then((response) => {
                if (response.data.status === 'success') {
                    this.zones = response.data.data.zones || response.data.data || []
                }
            })
        },
        loadReport() {
            this.loading = true
            this.summary = null
            UserService.authPostRequest('get-karad-list-report', {
                type:        parseInt(this.$route.params.type),
                district_id: this.district_id || null,
                zone_id:     this.zone_id     || null,
            }).then((response) => {
                this.loading = false
                if (response.data.status === 'success') {
                    const EXCL = [735]
                    this.added     = (response.data.data.added     || []).filter(u => !EXCL.includes(u.district_id))
                    this.not_added = (response.data.data.not_added || []).filter(u => !EXCL.includes(u.district_id))
                    this.summary   = response.data.data.summary   || null
                    // Build unit dropdown from loaded data
                    const unitMap = {}
                    ;[...this.added, ...this.not_added].forEach(u => { if (u.id && !unitMap[u.id]) unitMap[u.id] = u.name })
                    this.unit_options = Object.entries(unitMap).map(([id, name]) => ({ id: parseInt(id), name })).sort((a, b) => a.name.localeCompare(b.name))
                    this.unit_id = ''
                    // Collapse all karad zones by default (keyed by zone_name for stability)
                    const collapsed = {}
                    ;[...this.not_added].forEach(u => { collapsed['na_' + (u.zone_name || '')] = true })
                    ;[...this.added].forEach(u => { collapsed['aa_' + (u.zone_name || '')] = true })
                    this.collapsedKaradZones = collapsed
                }
            }).catch(() => { this.loading = false })
        },

        // Zones reached but not distributed to units — scoped by the receipt report's filters
        loadUndistributed() {
            this.ud_loading = true
            UserService.authPostRequest('get-zones-reached-no-unit-receipt', {
                type:        parseInt(this.$route.params.type),
                district_id: this.r_district_id || null,
                zone_id:     this.r_zone_id     || null,
            }).then((response) => {
                this.ud_loading = false
                this.ud_loaded = true
                if (response.data.status === 'success') {
                    this.ud_zones = response.data.data.zones || []
                }
            }).catch(() => { this.ud_loading = false })
        },

        // Receipt report
        onReceiptDistrictChange() {
            this.r_zone_id = ''
            this.r_zones = []
            this.r_unit_id = ''
            this.r_unit_options = []
            if (this.r_district_id) this.loadReceiptZones(this.r_district_id)
        },
        onReceiptZoneChange() {
            this.r_unit_id = ''
            this.r_unit_options = []
        },
        loadReceiptZones(districtId) {
            UserService.authGetRequest('get-zones', { district_id: districtId }).then((response) => {
                if (response.data.status === 'success') {
                    this.r_zones = response.data.data.zones || response.data.data || []
                }
            })
        },
        loadReceiptReport() {
            this.r_loading = true
            this.r_loaded  = false
            UserService.authPostRequest('get-fund-receipt-report', {
                type:        parseInt(this.$route.params.type),
                district_id: this.r_district_id || null,
                zone_id:     this.r_zone_id     || null,
            }).then((response) => {
                this.r_loading = false
                if (response.data.status === 'success') {
                    const EXCL_R = [735]
                    this.receipt_received_list     = (response.data.data.received     || []).filter(u => !EXCL_R.includes(u.district_id))
                    this.receipt_not_received_list = (response.data.data.not_received || []).filter(u => !EXCL_R.includes(u.district_id))
                    this.r_show_pending_only   = false
                    this.r_loaded              = true
                    // Collapse all zones by default
                    const collapsed = {}
                    const all = [...this.receipt_received_list, ...this.receipt_not_received_list]
                    all.forEach(u => { if (u.zone_id) collapsed[u.zone_id] = true })
                    this.collapsedZones = collapsed
                    // Build unit dropdown from loaded data
                    const rUnitMap = {}
                    all.forEach(u => { if (u.id && !rUnitMap[u.id]) rUnitMap[u.id] = u.name })
                    this.r_unit_options = Object.entries(rUnitMap).map(([id, name]) => ({ id: parseInt(id), name })).sort((a, b) => a.name.localeCompare(b.name))
                    this.r_unit_id = ''
                    // Preload the undistributed-zones count for the sub-tab badge
                    this.loadUndistributed()
                }
            }).catch(() => { this.r_loading = false })
        },
    },
}
</script>
